module.exports = __webpack_public_path__ + "static/img/R.186ecf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/R.png
// module id = JXYk
// module chunks = 0